import React from "react";
import { useSpring, animated } from "@react-spring/web";

function PredictSales({ isVisible, value, page, t }) {
  const nextValue = value?.[page]?.tomorrow ?? 0;

  const { val } = useSpring({
    from: { val: 0 },
    to: { val: isVisible ? nextValue : 0 },
    reset: true,
    config: { duration: 2000 },
  });

  if (!value || !page) {
    return <div className="error">데이터를 불러올 수 없습니다.</div>;
  }

  return (
    <div className="block w-full px-[5%] py-10 border border-[#f3f4f6] ">
      <div className="font-semibold text-[5.7vw]">
        {page === "daily"
          ? t("predictSales.title.daily")
          : page === "weekly"
          ? t("predictSales.title.weekly")
          : page === "monthly"
          ? t("predictSales.title.monthly")
          : t("predictSales.title.daily")}
      </div>
      <div className="flex flex-col h-[200px] items-center pt-[6vh] gap-2">
        <p className="text-neutral-500 text-sm font-medium">
          {t("Estimated revenue")}
        </p>
        <div className="inline-flex   items-baseline justify-center pb-[8vh]">
          <animated.span className="text-4xl sm:text-6xl font-extrabold text-green-600 ">
            {val.to((v) => Math.round(v).toLocaleString("ko-KR"))}
          </animated.span>
          <span className="text-lg sm:text-xl font-normal text-gray-500 ml-1">
            {t("compPredictSales.unit")}
          </span>
        </div>
      </div>
      <div className="notice">❕{t("predictSales.notice")}</div>
    </div>
  );
}

export default PredictSales;
